// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect, useCallback, memo} from 'react';
import { getOrganismosClientes, getOrganismoEmisorHabilitado } from '../../componentes/http/actions/OrganismoEmisorAction';
import { getTipoDocumentoHabilitado } from '../../componentes/http/actions/TipoDocumentoAction';
import { getEstadoTramitacionHabilitado } from '../../componentes/http/actions/EstadoTramitacionAction';
import { getRubroHabilitado, getRubrosCliente } from '../../componentes/http/actions/RubroAction';
import { getClasificacionDocumentoHabilitado } from '../../componentes/http/actions/ClasificacionDocumentoAction';
import { jwtDecode } from "jwt-decode";

const DataLoaderCliente = ({ onDataLoaded }) => {
    const [dataLoaded, setDataLoaded] = useState(false);
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const idUsuario = decoded["oid"];
    
    const fetchData = useCallback(async () => {
      try {
        // Primero intentamos cargar todas las demás categorías
        const [
          clasificaciones,
          estadosTramitacion,
          tiposDocumento,
        ] = await Promise.all([
          getClasificacionDocumentoHabilitado(token),
          getEstadoTramitacionHabilitado(token),
          getTipoDocumentoHabilitado(token),
        ]);

        // Intentamos obtener organismos específicos del cliente
        let organismos;
        try {
          organismos = await getOrganismosClientes(token, idUsuario);
        } catch (error) {
          console.warn("Error obteniendo organismos clientes, usando organismos habilitados como respaldo:", error);
          // Si falla, usamos getOrganismoEmisorHabilitado como respaldo
          organismos = await getOrganismoEmisorHabilitado(token);
        }

        let rubros;
        try {
          rubros = await getRubrosCliente(token, idUsuario);
        } catch (error) {
          console.warn("Error obteniendo rubros, usando rubros habilitados como respaldo:", error);
          // Si falla, usamos getRubroHabilitado como respaldo
          rubros = await getRubroHabilitado(token);
        }
  
        onDataLoaded({
          clasificaciones,
          estadosTramitacion,
          organismos,
          rubros,
          tiposDocumento,
        });
        setDataLoaded(true);
      } catch (error) {
        console.error("Error loading data:", error);
      }
    }, [idUsuario, token, onDataLoaded]);
  
    useEffect(() => {
      if (!dataLoaded) {
        fetchData();
      }
    }, [dataLoaded, fetchData]);
  
    return null;
  };
  
  export default memo(DataLoaderCliente);